export default "__VITE_ASSET__vHTdPNLtov63WEozDnkI4Q__"